import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CommonFunctionService {

	public loadingSpinner: Subject<boolean> = new Subject();
	// Ids to track loading process
	private loadingPros = {};

	constructor() { }

	setLoadingSpinner(isLoading: boolean, id?) {
		// No id is passed
		if (!id) {
			this.loadingSpinner.next(isLoading);
			return;
		}
		// Id is passed
		this.loadingPros[id] = isLoading;
		// Do not stop spinning if there are other loading processes
		if (!isLoading) {
			for (const proId of Object.keys(this.loadingPros)) {
				if (this.loadingPros[proId]) {
					return;
				}
			}
		}
		this.loadingSpinner.next(isLoading);
	}
	// Generate a 7 digit random number
	getRandomId() {
		return Math.floor(Math.random() * 1000000 + 1);
	}
}
